export const INCOME_FORM_LIST = 'incomeFormList';

export const AFFILIATED_BUSINESS_ARRANGEMENTS_FORM_LIST = 'abaFormList';

export const ADDITIONAL_PROPERTIES_FORM_LIST = 'apFormList';
